const aboutPages = [
  'condition',
  'company',
  'ebay-fees',
  'fees',
  'privacy',
  'returns',
  'terms',
  'tokushouhou',
  'phone-verify',
  'personal-information',
] as const

type AboutPage = typeof aboutPages[number]

const isAboutPage = (page: string | undefined): page is AboutPage => {
  return aboutPages.some(known => known === page)
}

export { aboutPages, isAboutPage }
export type { AboutPage }
